/*
  biobio-tone-picker.js — <biobio-tone-picker>
  Paleta de tons compacta (ref. Ollie, benchmark 10/06): swatch troca o
  painel de foto; CTA "Usar o tom no meu trio" pré-seleciona o tom nas
  DUAS Bases do bundle-selector-trio (cards 1 e 2) e rola pro seletor.

  Acoplamento com o trio é leve e com fallback: procura labels de swatch
  com data-component-index 1/2 e data-option-value contendo o código
  (#300); se não achar, só rola pro seletor.
*/
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const animateScrollTo = (target) => {
    const margem = () => parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    const destino = () => window.scrollY + target.getBoundingClientRect().top - margem();
    if (reduceMotion.matches) {
      window.scrollTo(0, destino());
      return;
    }
    const inicio = performance.now();
    const yInicial = window.scrollY;
    const duracao = 650;
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const frame = (agora) => {
      const t = Math.min(1, (agora - inicio) / duracao);
      window.scrollTo(0, yInicial + (destino() - yInicial) * ease(t));
      if (t < 1) requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  };

  class BioBioTonePicker extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      const swatches = Array.from(this.querySelectorAll('[data-tone-pick]'));
      const panels = Array.from(this.querySelectorAll('[data-tone-panel]'));

      swatches.forEach((btn, index) => {
        btn.tabIndex = index === 0 ? 0 : -1;
        btn.addEventListener('click', () => {
          swatches.forEach((b) => {
            b.setAttribute('aria-checked', String(b === btn));
            b.tabIndex = b === btn ? 0 : -1;
          });
          panels.forEach((p) => {
            p.hidden = p.dataset.tonePanel !== btn.dataset.tonePick;
          });
        });
        btn.addEventListener('keydown', (event) => {
          const moves = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
          if (!(event.key in moves)) return;
          event.preventDefault();
          const next = swatches[(index + moves[event.key] + swatches.length) % swatches.length];
          next.focus();
          next.click();
        });
      });

      if (!this.hasAttribute('data-aplicar-trio')) return;

      this.addEventListener('click', (event) => {
        const cta = event.target.closest('[data-tone-apply]');
        if (!cta) return;
        const codigo = cta.dataset.toneApply;
        let aplicados = 0;

        // Aplica o tom em TODAS as Bases da pagina. No trio sao 2 cards de Base;
        // numa LP multi-combo e 1 Base por combo. O match por data-option-value
        // contendo o codigo (#X00) so acerta swatch de Base -- as cores do BBS
        // nao tem "#". Skip esgotado (disabled). O .click() no input dispara o
        // handler de click do label do bundle-selector, que atualiza o estado
        // (selectedByComponent/pill) -- nao depender de :checked (quirk do tema).
        const alvos = document.querySelectorAll(
          'label.swatch[data-option-value*="' + codigo + '"] input'
        );
        alvos.forEach((alvo) => {
          if (alvo && !alvo.disabled) {
            alvo.click();
            aplicados += 1;
          }
        });

        const original = cta.textContent;
        cta.textContent = aplicados > 0 ? 'Tom aplicado!' : original;
        if (aplicados > 0) {
          setTimeout(() => { cta.textContent = original; }, 2500);
        }

        const ancora = document.getElementById(this.dataset.ancoraTrio || 'comprar');
        if (ancora) animateScrollTo(ancora);
      });
    }
  }

  if (!customElements.get('biobio-tone-picker')) {
    customElements.define('biobio-tone-picker', BioBioTonePicker);
  }
})();
